import { Icon } from "@shared/components";
import React, { useMemo } from "react";

import "./index.scss";

interface NewPatientCardStablePeriodInfoProps {
  signalName: string;
  stablePeriod: number;
  stableAvgPeriod: number;
  stablePeriodPercentage: number;
}

const NewPatientCardStablePeriodInfo = ({
  signalName,
  stableAvgPeriod,
  stablePeriod,
  stablePeriodPercentage,
}: NewPatientCardStablePeriodInfoProps) => {
  const percentageColor = useMemo(() => {
    return stablePeriod < stableAvgPeriod ? "green" : "red";
  }, [stablePeriod, stableAvgPeriod]);

  const percentageIcon = useMemo(() => {
    return stablePeriod < stableAvgPeriod ? "percentage-up" : "percentage-down";
  }, [stablePeriod, stableAvgPeriod]);

  return (
    <div className="new-patients-card-stable-period-info">
      <div className="new-patients-card-stable-period-info-row">
        {stableAvgPeriod ? <span className="stable-avg-value">{stableAvgPeriod}</span> : null}
        <span className="signal-name">
          {signalName} {!stableAvgPeriod ? "-" : ""}
        </span>
        {stablePeriodPercentage ? <Icon className="stable-percentage-icon" type={`${percentageIcon}`} /> : null}
        {stablePeriodPercentage ? (
          <span className={`stable-percentage-value ${percentageColor}`}>{stablePeriodPercentage}%</span>
        ) : null}
      </div>
      <div className="new-patients-card-stable-period-info-row">
        <span className="stable-period">Stable Period: {stablePeriod ? `${stablePeriod}` : "-"}</span>
      </div>
    </div>
  );
};

export default NewPatientCardStablePeriodInfo;
